import React from "react";

const ContentLoadingCard = () => {
  return (
    <div className="content-loading-card">
      <div className="content-part">
        <div className="content-line"></div>
        <div className="content-line line-one-third"></div>
        <div className="content-line line-half"></div>
      </div>
      <div className="action-part"></div>
    </div>
  );
};

export default ContentLoadingCard;